<div class="oops">
  <div class="oops__container only-desktop">
    <div class="oops__main-icon">
      <div class="oops__main-icon--format">
        <img src="../../../../assets/images/404map-icon.png" alt="Map icon" width="100%" height="100%">
      </div>
    </div>
    <div class="oops__info">
      <div class="oops__info--inner">
        <h1 class="oops__info__title">{{'PAGE_NOT_FOUND' | translate}}</h1>
      </div>
      <div class="oops__info--sec">
        <p class="oops__info--reset">{{'PAGE_LOOKS' | translate}}</p>
        <p class="oops__info--reset">{{'PAGE_DONT_WORRY' | translate}}</p>
        <p class="oops__info--reset">{{'PAGE_TIME' | translate}}</p>
      </div>
    </div>
    <div class="oops__navigation">
      <div class="oops__navigation--inner">
        <button (click)="navToHome()" class="oops__navigation--btn">{{'BACK_HOME' | translate}}</button>
        <div class="oops__navigation--btn-icon2">
          <img src="../../../../assets/images/404icon-homepage.png" alt="Home icon" width="100%" height="100%">
        </div>
      </div>
      <div class="oops__navigation--inner">
        <button class="oops__navigation--btn">{{'BACK_AGENDA' | translate}}</button>
        <div class="oops__navigation--btn-icon2">
          <img src="../../../../assets/images/404icon-agenda.png" alt="Agenda icon" width="100%" height="100%">
        </div>
      </div>
    </div>
    <div class="oops__destinations only-desktop">
      <h2>{{'POPULAR_DESTINATIONS' | translate}}</h2>
      <span class="oops__destinations--basic">
        <button (click)="navToCity(1)" class="oops__destinations--mobile--basic">Sevilla</button> -
        <button (click)="navToCity(22)" class="oops__destinations--mobile--basic">Las Palmas de Gran Canaria</button> -
        <button (click)="navToCity(24)" class="oops__destinations--mobile--basic">Málaga</button> -
        <button (click)="navToCity(20)" class="oops__destinations--mobile--basic">Córdoba</button> -
        <button (click)="navToCity(19)" class="oops__destinations--mobile--basic">Cádiz</button>
        <button (click)="navToCity(25)" class="oops__destinations--mobile--basic">Palma de Mallorca</button>
        <button (click)="navToCity(28)" class="oops__destinations--mobile--basic">Toledo</button>
        <button (click)="navToCity(27)" class="oops__destinations--mobile--basic">Santader</button>
        <button (click)="navToCity(26)" class="oops__destinations--mobile--basic">Santa Cruz de Tenerife</button>
      </span>
    </div>
  </div>
  <div class="oops__container__mobile only-mobile">
    <div class="oops__main-icon__mobile">
      <div class="oops__main-icon__mobile--format">
        <img src="../../../../assets/images/404map-icon.png" alt="Map icon" width="100px" height="100px">
        <h1 class="oops__main-icon__mobile__title">{{'PAGE_NOT_FOUND' | translate}}</h1>
      </div>
    </div>
    <div class="oops__info">
      <div class="oops__info--sec">
        <p class="oops__info--reset">{{'PAGE_LOOKS' | translate}}</p>
        <p class="oops__info--reset">{{'PAGE_DONT_WORRY' | translate}}</p>
        <p class="oops__info--reset">{{'PAGE_TIME' | translate}}</p>
      </div>
    </div>
    <div class="oops__navigation">
      <div class="oops__navigation--inner">
        <button (click)="navToHome()" class="oops__navigation--btn">{{'BACK_HOME' | translate}}</button>
        <div class="oops__navigation--btn-icon2">
          <img src="../../../../assets/images/404icon-homepage.png" alt="Home icon" width="100%" height="100%">
        </div>
      </div>
      <div class="oops__navigation--inner">
        <button class="oops__navigation--btn">{{'BACK_AGENDA' | translate}}</button>
        <div class="oops__navigation--btn-icon2">
          <img src="../../../../assets/images/404icon-agenda.png" alt="Agenda icon" width="100%" height="100%">
        </div>
      </div>
    </div>
  </div>
  <div class="oops__destinations--mobile only-mobile">
    <h2>{{'POPULAR_DESTINATIONS' | translate}}</h2>
    <div class="oops__destinations--mobile--basic">
      <button (click)="navToCity(1)" class="oops__destinations--mobile--basic">Sevilla</button> -
      <button (click)="navToCity(22)" class="oops__destinations--mobile--basic">Las Palmas de Gran Canaria</button> -
      <button (click)="navToCity(24)" class="oops__destinations--mobile--basic">Málaga</button> -
      <button (click)="navToCity(20)" class="oops__destinations--mobile--basic">Córdoba</button> -
      <button (click)="navToCity(19)" class="oops__destinations--mobile--basic">Cádiz</button>
      <button (click)="navToCity(25)" class="oops__destinations--mobile--basic">Palma de Mallorca</button>
      <button (click)="navToCity(28)" class="oops__destinations--mobile--basic">Toledo</button>
      <button (click)="navToCity(27)" class="oops__destinations--mobile--basic">Santader</button>
      <button (click)="navToCity(26)" class="oops__destinations--mobile--basic">Santa Cruz de Tenerife</button>
    </div>
  </div>
</div>